angular.module('unergie.main')
.controller('swaggerCtrl', ($scope, $state, BoFeaturesService, $sce) => {
    $scope.swaggerUri = $sce.trustAsResourceUrl(BoFeaturesService.get('swaggerDomain'))
})
